/**
 * Loads the projects the scope store can resolve against (card 1.1): the
 * personal bucket plus one bucket per team ON THE ROSTER — the same gate the
 * Graph uses (graphScopes.graphRecordScopes). A team the user left keeps its
 * rows in SQLite; reading only roster teams is what makes its projects vanish.
 *
 * A bucket that fails to read is left out and the result says the roster is
 * not fully known, so the store keeps a team project "pending" instead of
 * calling it gone and falling back to all.
 */
import { listLinks, listProjects } from '../graph/projectsStore';
import { listSpaceRecords } from './docSpacesStore';
import { graphRecordScopes } from '../graph/graphScopes';
import { useProjectScopeStore } from './projectScopeStore';

export async function readKnownProjects() {
  const { scopes, unavailable } = graphRecordScopes();
  const buckets = scopes.filter((s) => s.location !== 'device'); // projects live in personal / team buckets only
  const projects = [];
  const links = []; // membership only: `project:<id> —contains→ <node>` (slice 3: Boards, Documents, connections)
  const docSpaces = []; // card 4.3: documentation spaces + which page is in which
  const docSpaceMembers = [];
  let complete = !unavailable.includes('teams');
  for (const s of buckets) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const [p, l, sp] = await Promise.all([listProjects(s.scopeKey), listLinks(s.scopeKey), listSpaceRecords(s.scopeKey)]);
      projects.push(...p);
      docSpaces.push(...sp.spaces);
      docSpaceMembers.push(...sp.members);
      links.push(...l.filter((x) => x.rel === 'contains' && String(x.from).startsWith('project:')));
    } catch {
      complete = false;
    }
  }
  const rosterTeamIds = buckets.filter((s) => s.teamId != null).map((s) => s.teamId);
  return { projects, links, docSpaces, docSpaceMembers, rosterKnown: complete, rosterTeamIds };
}

/** Reads the projects and hands them to the scope store; returns what it read. */
export async function refreshProjectScope() {
  const known = await readKnownProjects();
  useProjectScopeStore.getState().setKnownProjects(known);
  return known;
}
